import { Preferences } from "../../profile/objects/preferences";
import { CUSTOM_INSURANCE_MODULE, DEFAULT_COLUMN } from "../constant/customInsuranceConstant";
import { Column } from "../objects/column";

/** field_name -> définition statique de colonne (source : DEFAULT_COLUMN, sans width). */
const COLUMN_MAP: Record<string, Column> = Object.fromEntries(
    DEFAULT_COLUMN.map((col) => [col.field_name, col])
);

/** Convertit les préférences API (Preferences[]) en Column[] pour le catalogue. */
export const setCustomInsurancePreference = (
    new_preferences: Preferences[],
    state_columns: Column[]
): { order_by: string, order: 'asc' | 'desc', columns: Column[], preferences: Preferences[] } => {
    const seen_field_names: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = '-created_date';
    let order: 'asc' | 'desc' = 'asc';

    new_preferences.forEach((preference: Preferences) => {
        if (preference.module !== CUSTOM_INSURANCE_MODULE) return;
        if (seen_field_names.includes(preference.field_name)) return;

        const col_def = COLUMN_MAP[preference.field_name];
        if (col_def) {
            columns.push({ ...col_def, checked: preference.active, last_updated: false });
            if (preference.ordering_asc !== null && col_def.order_by !== '') order_by = col_def.order_by;
        }
        preferences.push(preference);
        seen_field_names.push(preference.field_name);
        order = preference.ordering_asc !== null ? (preference.ordering_asc ? 'asc' : 'desc') : order;
    });

    // Compléter avec les colonnes du state non couvertes par les préférences API
    // (cas : nouvelle colonne ajoutée après que l'utilisateur ait déjà des prefs).
    if (columns.length !== state_columns.length) {
        state_columns.forEach((column) => {
            if (!columns.some((c) => c.field_name === column.field_name)) {
                columns.push({ ...column });
            }
        });
    }

    return { order_by, order, columns, preferences };
};
